import styled from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

// Плеєр ДЗ поверх стилів презентації (PresentPage.styled)

export const StageLock = styled.div`
  width: 100%;
  height: 100%;
  pointer-events: ${(props) => (props.$locked ? "none" : "auto")};
`;

export const ReviewBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 14px;
  padding: 10px 18px;
  font-family: ${font.text};
  font-size: 15px;
  color: #FFFFFF;
  background: ${colors.brandDeep};

  span {
    opacity: 0.85;
  }
`;

export const Dots = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 6px;
`;

const dotColor = (state) =>
  state === "ok" ? colors.success : state === "miss" ? colors.danger : state === "part" ? colors.amber : state === "done" ? colors.brand : "rgba(255, 255, 255, 0.25)";

export const Dot = styled.button`
  width: ${(props) => (props.$current ? "26px" : "12px")};
  height: 12px;
  border-radius: 6px;
  background: ${(props) => dotColor(props.$state)};
  outline: ${(props) => (props.$current ? "2px solid #FFFFFF" : "none")};
  outline-offset: 2px;
  cursor: pointer;
  transition: width 0.2s ease;
`;

export const Submit = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 800;
  color: ${colors.ink};
  background: ${colors.amber};
  box-shadow: ${shadow.card};
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const Secondary = styled.button`
  padding: 10px 18px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 700;
  color: ${colors.ink};
  background: ${colors.bg};
  cursor: pointer;
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  place-items: center;
  padding: 16px;
  background: rgba(20, 18, 45, 0.6);
`;

export const Dialog = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: min(440px, 100%);
  padding: 28px 24px;
  border-radius: ${radius.xl};
  font-family: ${font.text};
  text-align: center;
  color: ${colors.ink};
  background: ${colors.surface};
  box-shadow: ${shadow.raised};

  h3 {
    font-size: 22px;
    font-weight: 800;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    color: ${colors.muted};
  }
`;

export const DialogButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
`;

export const Star = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  font-size: 34px;
  font-weight: 800;
  color: ${colors.ink};

  span {
    font-size: 18px;
  }
`;

export const Toast = styled.div`
  position: fixed;
  left: 50%;
  bottom: 80px;
  z-index: 60;
  padding: 12px 18px;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-weight: 700;
  color: #FFFFFF;
  background: ${colors.danger};
  transform: translateX(-50%);
  cursor: pointer;
`;

// Телефон вертикально — сцена 16:9 замала; просимо повернути
export const Rotate = styled.div`
  display: none;
  padding: 10px 16px;
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  color: ${colors.ink};
  background: ${colors.amberSoft};

  @media (max-width: 700px) and (orientation: portrait) {
    display: block;
  }
`;
